module.exports = __webpack_public_path__ + "static/yves-hoppe-fcf7e0e67437de4545fd6f93593bb6e1.jpg";